import { useState, useContext, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';
import apiRequest from '../../lib/apiRequest';
import Modal from '../modal/Modal';
import './card.scss';

const Card = ({ item, isSaved }) => {
  const [modalActive, setModalActive] = useState(false);
  const { currentUser } = useContext(AuthContext);
  const [saved, setSaved] = useState(isSaved || item.isSaved);

  // Функция форматирования цены
  const formatPrice = (price) => {
    return '₦ ' + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  const handleDelete = useCallback(async () => {
    try {
      await apiRequest.delete(`/posts/${item.id}`);
      alert('Ad successfully deleted!');
      window.location.reload();
    } catch (error) {
      alert('Error deleting ad!');
    }
  }, [item.id]);

  const handleSave = useCallback(async () => {
    try {
      await apiRequest.post('/users/save', { postId: item.id });
      setSaved((prev) => !prev);
    } catch (err) {
      setSaved((prev) => !prev);
    }
  }, [item.id]);

  return (
    <div className="card">
      <Link to={`/${item.id}`} className="imageContainer">
        <img
          src={
            item.images && item.images.length > 0
              ? item.images[0]
              : '/noproduct.webp'
          }
          alt={item.title}
          loading="lazy"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = '/noproduct.webp';
          }}
        />
      </Link>

      <div className="textContainer">
        <h3 className="title">
          <Link to={`/${item.id}`}>{item.title}</Link>
        </h3>
        <p className="address">
          <img src="/pin.png" alt="Location" />
          <span>
            {item.country}, {item.city}
          </span>
        </p>

        <div className="icons">
          {/*  Используем formatPrice здесь */}
          <p className="price">{formatPrice(item.price)}</p>

          {!currentUser ? (
            <div className="icon">
              <Link to="/login">
                <img src="/save.png" alt="Register to save" />
              </Link>
            </div>
          ) : (
            <div className="icons">
              {item.userId !== currentUser?.user?.id && (
                <div className="icon" onClick={handleSave}>
                  <img
                    src={saved ? '/saved.png' : '/save.png'}
                    alt={saved ? 'Saved' : 'Save'}
                  />
                </div>
              )}

              {item.userId === currentUser?.user?.id && (
                <div className="bottom">
                  <div className="icon">
                    <Link to={`/edit/${item.id}`}>
                      <img src="/edit.png" alt="Edit ad" />
                    </Link>
                  </div>
                  <div className="icon" onClick={() => setModalActive(true)}>
                    <img src="/delete.png" alt="Delete ad" />
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>

      <Modal active={modalActive} setActive={setModalActive}>
        <h3>Delete this ad? Are you sure?</h3>
        <div className="buttons">
          <button className="button" onClick={handleDelete}>
            Yes
          </button>
          <button className="button" onClick={() => setModalActive(false)}>
            No
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default Card;
